// extracted by mini-css-extract-plugin
module.exports = {"loader":"loading_loader__DsNnN","l7":"loading_l7__FAyzI"};